"use client";
import React from "react";
const CheckboxContext = React.createContext(null);
export const useCheckboxGroup = () => React.useContext(CheckboxContext);
export default CheckboxContext;
